import clsx from "clsx";
import { BaseHit } from "instantsearch.js";
import { Dispatch, FC, SetStateAction } from "react";
import { useStats, useInstantSearch, useHits } from "react-instantsearch";
import { AlgoliaTechBlog } from "@/lib/algolia";
import { HitComponent } from "./HitComponent/HitComponent";

interface Props {
  selectedId?: string;
  className?: string;
  setIsShow?: Dispatch<SetStateAction<boolean>>;
  isMobile?: boolean;
}

export const SearchHits: FC<Props> = ({ selectedId, className, setIsShow, isMobile }) => {
  const { query } = useStats();
  const { status } = useInstantSearch();
  const { hits } = useHits<BaseHit & AlgoliaTechBlog>();

  return status === "idle" && hits.length === 0 ? (
    <div className={className}>
      <div className="px-4">No results for query {query}</div>
    </div>
  ) : hits.length ? (
    <div className={className}>
      <ul>
        {hits.map((hit, index) => {
          return (
            <li
              key={hit.objectID}
              className={clsx(
                "w-full border-b border-solid border-gray-pale px-3",
                index === hits.length - 1 && "!border-b-0",
                isMobile && "p-4",
              )}
            >
              <HitComponent
                hit={hit}
                selected={hit.objectID === selectedId}
                onClick={() => {
                  setIsShow?.(false);
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};
